// Cementing Report — template + checklist.
import { polishProse, MISSING } from "@/lib/ddr/templates";

const orMissing = (v) => (v && String(v).trim() ? String(v).trim() : MISSING);

export function buildCementingReport(state) {
  const h = state.header || {};
  const job = state.job || {};
  const slurry = state.slurry || {};
  const displ = state.displacement || {};
  const press = state.pressures || {};
  const returns = state.returns || {};

  const lines = [];
  const push = (s) => { if (s !== null && s !== undefined) lines.push(s); };
  const sec = (label) => lines.push(`\n=== ${label.toUpperCase()} ===\n`);

  sec("Report Header");
  push(`Date: ${orMissing(h.reportDate)}`);
  push(`Rig: ${orMissing(h.rigName)}  ·  Well: ${orMissing(h.wellName)}`);
  push(`Operator / Client: ${orMissing(h.operator)}`);
  push(`Cementing Company: ${orMissing(h.cementingCompany)}`);
  push(`Prepared By: ${orMissing(h.preparedBy)}`);

  sec("Job Summary");
  push(`Job Type: ${orMissing(job.jobType)}  ·  Casing String: ${orMissing(job.casingString)}`);
  push(`Casing Size: ${orMissing(job.casingSize)}  ·  Hole Size: ${orMissing(job.holeSize)}`);
  push(`Shoe Depth (MD/TVD): ${orMissing(job.shoeMd)} / ${orMissing(job.shoeTvd)}`);
  push(`TOC Planned: ${orMissing(job.tocPlanned)}  ·  TOC Estimated: ${orMissing(job.tocEstimated)}`);
  push(`Mud Weight: ${orMissing(job.mudWeight)}  ·  Hole Temperature: ${orMissing(job.holeTemp)}`);

  sec("Slurry Design");
  push(`Lead Slurry — Density: ${orMissing(slurry.leadDensity)}  ·  Volume: ${orMissing(slurry.leadVolume)}  ·  Yield: ${orMissing(slurry.leadYield)}`);
  push(`Tail Slurry — Density: ${orMissing(slurry.tailDensity)}  ·  Volume: ${orMissing(slurry.tailVolume)}  ·  Yield: ${orMissing(slurry.tailYield)}`);
  push(`Spacer — Type: ${orMissing(slurry.spacerType)}  ·  Volume: ${orMissing(slurry.spacerVolume)}`);
  push(`Additives: ${polishProse(slurry.additives) || MISSING}`);
  push(`Mix Water: ${orMissing(slurry.mixWater)}`);

  sec("Displacement Plan");
  push(`Displacement Fluid: ${orMissing(displ.fluid)}  ·  Volume: ${orMissing(displ.volume)}  ·  Rate: ${orMissing(displ.rate)}`);
  push(`Plug Bumped: ${displ.plugBumped ? "Yes" : "No"}  ·  Final Bump Pressure: ${orMissing(displ.bumpPressure)}`);
  push(`Float Held: ${displ.floatHeld ? "Yes" : "No"}  ·  Returns During Displacement: ${orMissing(displ.returnsDuringDispl)}`);

  sec("Pressures");
  push(`Pump Pressure Max: ${orMissing(press.pumpMax)}  ·  Circulating Pressure: ${orMissing(press.circulating)}`);
  push(`Lift Pressure: ${orMissing(press.lift)}  ·  Final Pressure: ${orMissing(press.final)}`);
  const pressNotes = polishProse(press.notes);
  if (pressNotes) push(`Pressure Notes: ${pressNotes}`);

  sec("Returns");
  push(`Full Returns: ${returns.fullReturns ? "Yes" : "No"}  ·  Losses Observed: ${orMissing(returns.lossesObserved)}`);
  push(`Volume Returned: ${orMissing(returns.volumeReturned)}`);
  const rNotes = polishProse(returns.notes);
  if (rNotes) push(`Returns Notes: ${rNotes}`);

  sec("Job Notes");
  push(polishProse(state.notes?.roughNotes) || MISSING);

  sec("Recommendations");
  push(polishProse(state.recommendations?.text) || MISSING);

  return lines.join("\n");
}

export function cementingReviewChecklist(state) {
  const out = [];
  const h = state.header || {};
  const job = state.job || {};
  const slurry = state.slurry || {};
  if (!h.reportDate) out.push("Report date missing");
  if (!h.rigName) out.push("Rig name missing");
  if (!h.wellName) out.push("Well name missing");
  if (!h.cementingCompany) out.push("Cementing company missing");
  if (!h.preparedBy) out.push("Prepared-By missing");
  if (!job.jobType) out.push("Job type missing");
  if (!job.casingString) out.push("Casing string missing");
  if (!slurry.tailDensity) out.push("Tail slurry density missing");
  if (!slurry.tailVolume) out.push("Tail slurry volume missing");
  return out;
}

export const CMT_QUICK_PHRASES = [
  "Job executed per program.",
  "Full returns observed throughout.",
  "Partial losses observed during job.",
  "Plug bumped at planned pressure.",
  "Float held — pressure bled to zero.",
  "Awaiting CBL/USIT logging.",
  "Recommend WOC per program.",
  "No abnormal observations.",
];
